import { Box, Flex, Image, Link, Text } from "@chakra-ui/react";

interface ImageCardProps {
  src: string;
  title: string;
  desc: string;
  jumpUrl: string;
  disableJump?: boolean;
}
export default function ImageCard(props: ImageCardProps) {
  const { src, title, desc, jumpUrl, disableJump = false } = props;
  const onJump = () => {
    if (disableJump) return;
    window.open(jumpUrl, "_blank");
  };
  return (
    <Box
      className="business_imageCard"
      w="350px"
      h="288px"
      rounded="8px"
      overflow="hidden"
      bg="white"
      shadow="2px 2px 16px 0 #3370FF19"
      border="1px solid transparent"
      transition="transform 0.1s"
      _hover={{
        borderColor: "#165DFF",
        transform: "translateY(-5px)",
        shadow: "2px 2px 16px 2px #3370FF19",
      }}
      css={{
        "&:hover .use_immediately": {
          display: "block",
          color: disableJump ? "#C9CDD4" : "#165DFF",
        },
      }}
    >
      <Box w="100%" maxH="186px">
        <Image src={src} objectFit="cover" />
      </Box>
      <Flex mt="16px" px="16px" justify="space-between">
        <Text fontWeight={600}>{title}</Text>
        {/* {jumpUrl && (
          <Text
            className="use_immediately"
            userSelect="none"
            cursor="pointer"
            display="none"
            onClick={onJump}>
            查看文档
          </Text>
        )} */}
      </Flex>
      <Text fontSize="14px" color="#4E5969" mt="8px" px="16px">
        {desc}
      </Text>
    </Box>
  );
}
